<template>
	<QuotedVsActualTable :project-id="projectId" />
</template>

<script lang="ts" setup>
import { QuotedVsActualTable } from '@/features/Project';
import { type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
}>();
</script>
